import React from 'react';
import './ProofSecuritySection.css';

const ProofSecuritySection: React.FC = () => {
  return (
    <section className="proof-security-section">
      <div className="container">
        <div className="proof-security-content">
          <div className="proof-security-header">
            <h2>Resultados & Segurança</h2>
            <div className="proof-security-divider"></div>
          </div>

          <div className="proof-security-grid">
            <div className="proof-security-card">
              <h3>Resultados Que Contam</h3>
              <ul>
                <li>~20 min poupados por cliente</li>
                <li>40+ h/mês por consultor</li>
                <li>Aumento de cross-sell e renovações</li>
                <li>Vendas Ativas</li>
                <li>Acompanhamento Proativo</li>
                <li>Qualificação de Leads</li>
                <li>Formação e melhoria continua</li>
              </ul>
            </div>

            <div className="proof-security-card">
              <h3>Segurança</h3>
              <p>
              Cumprimos rigorosamente todas as normas europeias de proteção de dados (RGPD) e as mais recentes legislações aplicáveis.
              Todos os seus dados são tratados com o mais elevado padrão de segurança, confidencialidade e transparência.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProofSecuritySection;
